<div class="error-container">
  <app-error [errorCode]="404" [customError]="error"></app-error>
</div>
